<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="eventTemplate.title"
      :counter="50"
      :rules="titleRules"
      label="Title"
      required
    ></v-text-field>

    <v-text-field
      v-model="eventTemplate.location"
      :counter="50"
      :rules="locationRules"
      label="Location"
      required
    ></v-text-field>

    <v-textarea
      v-model="eventTemplate.description"
      :rules="descriptionRules"
      :counter="500"
      label="Description"
      required
    ></v-textarea>

    <v-select
      v-model="eventTemplate.status"
      :items="statuses"
      :rules="[v => !!v || 'Status is required']"
      label="Status"
      required
    ></v-select>

    <v-btn
      :disabled="!valid"
      @click="save"
    >
      Save
    </v-btn>
  </v-form>
</template>
<script>
import { db } from '@/services/firebase';

export default {
    name: 'EditEventForm',
    props: ['id'],
    data: () => ({
      valid: true,
      titleRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 50) || 'Name must be less than 50 characters'
      ],
      locationRules: [
        v => !!v || 'Location is required',
        v => (v && v.length <= 50) || 'Location must be less than 50 characters'
      ],
      descriptionRules: [
        v => !!v || 'Description is required',
        v => (v && v.length <= 500) || 'Name must be less than 500 characters'
      ],
      statuses: [
        'public',
        'private'
      ],
    }),
    firestore () {
      return {
        eventTemplate: db.collection('event_templates').doc(this.id)
      }
    },
    methods: {
      save () {
        const data = this.eventTemplate;
        if (this.$refs.form.validate()) {
          db.collection('event_templates')
            .doc(this.id)
            .update({
              title: data.title,
              description: data.description,
              status: data.status,
              location: data.location
            });
        }
      }
    }
}
</script>